import { hasClientRing, visuallyHidden } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	root: {
		...shorthands.padding("1rem"),
		minWidth: "18rem",
		maxWidth: "30rem",
	},
	hasClientBorder: hasClientRing(),
	visuallyHidden: visuallyHidden(),
	header: {
		minWidth: 0,
	},
	headerName: {
		overflowWrap: "anywhere",
	},
	headerSecondary: {
		color: tokens.colorNeutralForeground2,
		fontSize: tokens.fontSizeBase200,
		lineHeight: tokens.lineHeightBase200,
		overflowWrap: "anywhere",
	},
	detailsList: {
		display: "flex",
		flexDirection: "column",
		rowGap: "0.625rem",
		minWidth: 0,
	},
	detailIcon: {
		display: "flex",
		flexShrink: 0,
		color: tokens.colorNeutralForeground3,
	},
	detailValue: {
		fontSize: tokens.fontSizeBase200,
		lineHeight: tokens.lineHeightBase200,
		overflowWrap: "anywhere",
	},
});
